import { h } from "preact";
import "./passwordstrength.scss";

interface Props {
    strength: number;
    valid: boolean;
}

export function PasswordStrength(props: Props) {
    return (
        <div class="component-password-strength">
            <div style={{ "--strength": Math.max(5, Math.min(100, props.strength)) + "%" }} class={props.valid ? "valid" : undefined} />
        </div>
    );
}

export function computePasswordStrength(password?: string): number {
    if (!password) return 0;
    // todo: detect uppercase, lowercase, numbers, symbols, repeating-characters
    const strength = Math.floor(password.length * 100 / 16);
    return strength;
}
